import {
  GrantProgramCandidateRule,
  GrantProgramEntryType,
  Program
} from '@percent/admin-dashboard/api/actions/grantProgram/grantProgram.types'

export const mockGrantPrograms: Program[] = [
  {
    id: '1',
    name: 'Community Fund',
    opensAt: '2025-06-09',
    closesAt: '2025-12-31',
    partnerId: '1',
    nominationsEnabled: true,
    validationSubmissionConfigurationId: '1',
    budgetMin: 1000,
    budgetMax: 2000,
    currency: 'USD',
    createdAt: '2025-06-09',
    stateMachineDefinition: 'stateMachineDefinition',
    description: 'Community Fund description',
    nominationFormId: '1',
    nominationDeadline: '2025-06-09',
    nonprofitCcEmail: 'example@org.com',
    entryType: GrantProgramEntryType.NOMINATION,
    candidateRule: GrantProgramCandidateRule.UNIQUE_PER_ORG,
    shareNominatorInfoWithOrg: true
  },
  {
    id: '2',
    name: 'Housing Grant',
    partnerId: '1',
    nominationsEnabled: false,
    nominationFormId: '',
    validationSubmissionConfigurationId: '2',
    budgetMin: 500,
    budgetMax: 10000,
    currency: 'USD',
    createdAt: '2025-06-15',
    stateMachineDefinition: 'stateMachineDefinition',
    nonprofitCcEmail: null,
    entryType: GrantProgramEntryType.APPLICATION,
    candidateRule: GrantProgramCandidateRule.UNIQUE_PER_NOMINATION
  },
  {
    id: '3',
    name: 'Welfare Grant',
    partnerId: '1',
    nominationsEnabled: false,
    nominationFormId: '3',
    validationSubmissionConfigurationId: '2',
    budgetMin: 400,
    budgetMax: 20000,
    currency: 'USD',
    createdAt: '2025-06-15',
    stateMachineDefinition: 'stateMachineDefinition',
    opensAt: null,
    closesAt: null,
    nominationDeadline: null,
    nonprofitCcEmail: null,
    entryType: GrantProgramEntryType.NOMINATION,
    candidateRule: GrantProgramCandidateRule.UNIQUE_PER_ORG,
    shareNominatorInfoWithOrg: true
  },
  {
    id: '4',
    name: 'Invitation Grant',
    partnerId: '1',
    nominationsEnabled: false,
    nominationFormId: '4',
    validationSubmissionConfigurationId: '3',
    budgetMin: 200,
    budgetMax: 5000,
    currency: 'USD',
    createdAt: '2025-07-01',
    stateMachineDefinition: 'stateMachineDefinition',
    opensAt: null,
    closesAt: null,
    nominationDeadline: null,
    nonprofitCcEmail: null,
    entryType: GrantProgramEntryType.INVITATION,
    candidateRule: GrantProgramCandidateRule.UNIQUE_PER_ORG
  }
]
